import { SearchX } from 'lucide-react';
import { ButtonLink, EmptyState } from '../components/ui';

export function NotFoundPage() {
  return (
    <EmptyState title="Seite nicht gefunden" icon={<SearchX className="size-10" />}>
      <ButtonLink to="/" className="mt-2">
        Zur Übersicht
      </ButtonLink>
    </EmptyState>
  );
}
